import React, { useEffect, useState } from 'react';
import { Button, message, Statistic, Row, Col, Card } from 'antd';
import { ReloadOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import AlertStats from '../../components/admin/AlertStats';
import { validationService, ValidationAlert } from '../../services/validation';
import CommonCard from '../../components/CommonCard';

const AdminDashboard: React.FC = () => {
    const [alerts, setAlerts] = useState<ValidationAlert[]>([]);
    const [loading, setLoading] = useState(false);

    const fetchAlerts = async () => {
        setLoading(true);
        try {
            // Get all alerts (both resolved and unresolved)
            const data = await validationService.getAlerts();
            setAlerts(data);
        } catch (error) {
            console.error('Failed to fetch alerts:', error);
            message.error('加载大盘数据失败');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAlerts();
    }, []);

    // Calculate simple stats for quick view
    const pendingCount = alerts.filter(a => !a.is_resolved).length;
    const criticalCount = alerts.filter(a => !a.is_resolved && a.severity === 'CRITICAL').length;

    return (
        <div style={{ padding: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <div>
                    <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 600, color: '#1f1f1f' }}>系统概览</h1>
                    <p style={{ margin: '4px 0 0', color: '#8c8c8c' }}>系统运行状态与数据采集大盘</p>
                </div>
                <Button
                    type="primary"
                    icon={<ReloadOutlined />}
                    onClick={fetchAlerts}
                    loading={loading}
                    style={{ height: 40, borderRadius: 6 }}
                >
                    刷新数据
                </Button>
            </div>

            <AlertStats alerts={alerts} />

            <Row gutter={[24, 24]} style={{ marginTop: '24px' }}>
                <Col span={12}>
                    <CommonCard title="快捷操作">
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <Link to="/admin/validation">
                                <Button block size="large" style={{ textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span>处理数据异常 ({pendingCount} 待处理)</span>
                                    <ArrowRightOutlined />
                                </Button>
                            </Link>
                            <Link to="/admin/intelligence">
                                <Button block size="large" style={{ textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span>审核情报数据</span>
                                    <ArrowRightOutlined />
                                </Button>
                            </Link>
                        </div>
                    </CommonCard>
                </Col>
                <Col span={12}>
                    <CommonCard title="系统状态">
                        <div style={{ padding: '10px 0' }}>
                            <p><strong>运行环境:</strong> 生产环境 (Production)</p>
                            <p><strong>后端服务:</strong> 在线 (Online)</p>
                            <p><strong>调度任务:</strong> 运行中 (Active)</p>
                        </div>
                    </CommonCard>
                </Col>
            </Row>
        </div>
    );
};

export default AdminDashboard;
